"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useContractKitMethods = void 0;
var react_1 = require("react");
var constants_1 = require("./constants");
var contract_kit_provider_1 = require("./contract-kit-provider");
function useContractKitMethods() {
    var _this = this;
    var _a = react_1.useContext(contract_kit_provider_1.ContractKitContext), _b = _a[0], connector = _b.connector, networks = _b.networks, dispatch = _a[1];
    var destroy = react_1.useCallback(function () { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, connector.close()];
                case 1:
                    _a.sent();
                    dispatch('destroy');
                    return [2 /*return*/];
            }
        });
    }); }, [dispatch, connector]);
    var initConnector = react_1.useCallback(function (nextConnector) { return __awaiter(_this, void 0, void 0, function () {
        var initialisedConnector, e_1;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, nextConnector.initialise()];
                case 1:
                    initialisedConnector = _b.sent();
                    dispatch('initialisedConnector', initialisedConnector);
                    (_a = initialisedConnector.onNetworkChange) === null || _a === void 0 ? void 0 : _a.call(initialisedConnector, function (chainId) {
                        var network = networks.find(function (n) { return n.chainId === chainId; });
                        // TODO: We should probably throw an error if we can't find the new chainId
                        network && dispatch('setNetwork', network);
                    });
                    return [2 /*return*/, initialisedConnector];
                case 2:
                    e_1 = _b.sent();
                    console.error('[use-contractkit] Error initializing connector', nextConnector.type, e_1);
                    dispatch('setConnectorInitError', e_1);
                    throw e_1;
                case 3: return [2 /*return*/];
            }
        });
    }); }, [dispatch, networks]);
    var updateNetwork = react_1.useCallback(function (network) {
        dispatch('setNetwork', network);
    }, [dispatch]);
    var connect = react_1.useCallback(function () { return __awaiter(_this, void 0, void 0, function () {
        var connectionResultPromise, newConnector;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    connectionResultPromise = new Promise(function (resolve) {
                        dispatch('setConnectionCallback', resolve);
                    });
                    return [4 /*yield*/, connectionResultPromise];
                case 1:
                    newConnector = _a.sent();
                    dispatch('setConnectionCallback', null);
                    if (newConnector === false) {
                        throw new Error('Connection cancelled');
                    }
                    return [2 /*return*/, newConnector];
            }
        });
    }); }, [dispatch]);
    var getConnectedKit = react_1.useCallback(function () { return __awaiter(_this, void 0, void 0, function () {
        var initialisedConnection;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    initialisedConnection = connector;
                    if (!(connector.type === constants_1.WalletTypes.Unauthenticated)) return [3 /*break*/, 2];
                    return [4 /*yield*/, connect()];
                case 1:
                    initialisedConnection = _a.sent();
                    return [3 /*break*/, 4];
                case 2:
                    if (!!initialisedConnection.initialised) return [3 /*break*/, 4];
                    return [4 /*yield*/, initConnector(initialisedConnection)];
                case 3:
                    _a.sent();
                    _a.label = 4;
                case 4: return [2 /*return*/, initialisedConnection.kit];
            }
        });
    }); }, [connect, connector, initConnector]);
    var performActions = react_1.useCallback(function () {
        var operations = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            operations[_i] = arguments[_i];
        }
        return __awaiter(_this, void 0, void 0, function () {
            var kit, results, _a, operations_1, op, _b, _c, e_2;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0: return [4 /*yield*/, getConnectedKit()];
                    case 1:
                        kit = _d.sent();
                        dispatch('setPendingActionCount', operations.length);
                        results = [];
                        _a = 0, operations_1 = operations;
                        _d.label = 2;
                    case 2:
                        if (!(_a < operations_1.length)) return [3 /*break*/, 8];
                        op = operations_1[_a];
                        _d.label = 3;
                    case 3:
                        _d.trys.push([3, 5, , 6]);
                        _c = (_b = results).push;
                        return [4 /*yield*/, op(kit)];
                    case 4:
                        _c.apply(_b, [_d.sent()]);
                        return [3 /*break*/, 6];
                    case 5:
                        e_2 = _d.sent();
                        dispatch('setPendingActionCount', 0);
                        throw e_2;
                    case 6:
                        dispatch('decrementPendingActionCount');
                        _d.label = 7;
                    case 7:
                        _a++;
                        return [3 /*break*/, 2];
                    case 8: return [2 /*return*/, results];
                }
            });
        });
    }, [getConnectedKit, dispatch]);
    return {
        destroy: destroy,
        initConnector: initConnector,
        updateNetwork: updateNetwork,
        connect: connect,
        getConnectedKit: getConnectedKit,
        performActions: performActions,
    };
}
exports.useContractKitMethods = useContractKitMethods;
//# sourceMappingURL=use-contract-kit-methods.js.map